type CreateDownloadLinkParams = {
  blob?: Blob;
  objectUrl?: string;
  filename?: string;
  anchorElement?: HTMLAnchorElement | null;
};

/**
 * Triggers download of a provided Blob or object URL.
 * - If `anchorElement` is provided, it will be used to perform the click.
 * - Otherwise, a temporary hidden anchor is created and cleaned up.
 * - If `objectUrl` is not provided but `blob` is, it will be created and revoked.
 */

export const createDownloadLink = (params: CreateDownloadLinkParams): void => {
  const { blob, objectUrl, filename, anchorElement } = params;

  if (!blob && !objectUrl) {
    console.error(
      "createDownloadLink: neither 'blob' nor 'objectUrl' provided. No download will occur."
    );

    return;
  }

  const url = objectUrl || URL.createObjectURL(blob as Blob);

  const hasUsableAnchor =
    !!anchorElement && anchorElement instanceof HTMLAnchorElement;

  const anchor: HTMLAnchorElement = hasUsableAnchor
    ? (anchorElement as HTMLAnchorElement)
    : document.createElement("a");

  if (!hasUsableAnchor) {
    anchor.style.display = "none";
    document.body.appendChild(anchor);
  }

  anchor.href = url;
  if (filename) anchor.download = filename;
  anchor.click();

  if (!hasUsableAnchor) {
    document.body.removeChild(anchor);
  }

  URL.revokeObjectURL(url);
};
